import React, { FunctionComponent, useState } from 'react';
import { UfpbFileError, UfpbImagePortraitSlash } from '../icons';

import IconHandler from './IconHandler';
import { ImageHandlerType } from '../types';
import { useTranslation } from 'react-i18next';

const ImageHandler: FunctionComponent<ImageHandlerType> = ({
  src = '',
  alt,
  className,
  withLabel = false,
  noImageTitle,
  ...props
}) => {
  const [error, setError] = useState(false);
  const { t } = useTranslation();

  return error ? (
    <div
      className={`d-flex flex-column align-items-center justify-content-center ${className}`}
      title={t('label.arquivo_corrompido')}
    >
      <IconHandler Icon={UfpbFileError} size={'2.5em'} className={'flex-shrink-0'} />
      {withLabel && <span className={'text-center mt-2 lh-1'}>{t('label.arquivo_corrompido')}</span>}
    </div>
  ) : src ? (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null; // prevents looping
        setError(true);
      }}
      {...props}
    />
  ) : (
    <div
      className={`d-flex flex-column align-items-center justify-content-center ${className}`}
      title={noImageTitle ? noImageTitle : t('label.sem_imagem')}
    >
      <IconHandler Icon={UfpbImagePortraitSlash} size={'2.5em'} className={'flex-shrink-0'} />
      {withLabel && <span className={'text-center mt-2 lh-1'}>{noImageTitle}</span>}
    </div>
  );
};

export default ImageHandler;
